import reducer from './reducer';

export const {
  logout,
  resetAdminCodeAttempt,
  resetSchedule,
  setSchedule,
  setCookies,
  setLoginData,
  setNotFound,
  resetLoginData,
  clearCodeLoginError,
  dismissMobilityWarning,
  setCodeReopenVerified,
  clearCodeReopenVerified,
} = reducer.actions;
